module.exports = __webpack_public_path__ + "static/media/promotion01.51c1cf91.jpg";